<template>
  <pop-up-layout 
    :title="$t('reservas.comprador.comprobarEmail.titulo')"
    :description="$t('reservas.comprador.comprobarEmail.descripcion', {
      comprador: reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.comprador.comprador') : $t('reservas.comprador.arrendatario')
    })"
    :saving="saving"
    @volver="$parent.hide()"
    @aceptar="aceptar"
    :aceptar="$t('reservas.comprador.aceptar')"
  >
    <v-form ref="form" v-model="valid">
    <div v-for="(comprador, i) in mCompradores" :key="'comprador' + i">
      <o-medium-title v-if="compradores[i].juridico">{{compradores[i].nombre}}</o-medium-title>
      <o-medium-title v-if="!compradores[i].juridico">{{compradores[i].nombre}} {{compradores[i].kyc.apellidos}}</o-medium-title>
      <v-layout row wrap>
        <v-flex xs12 px-2>
            <v-text-field
              :label="$t('reservas.formularioFisico.email')"
              :name="'email[' + i + ']'"
              :rules="[rules.required, rules.emailOpcional, rules.max(256)]"
              v-model="comprador.email"
            />
        </v-flex>
        <v-flex xs12 md7 lg7 xl4 px-2>
          <v-autocomplete
            hide-details
            v-model="comprador.codigoPrefijoTelefonicoId"
            :name="'prefijo[' + i + ']'"
            :items="prefijos"
            :label="$t('reservas.formularioFisico.prefijo')"
            item-text="nombre"
            item-value="id"
            :rules="[rules.required]"
            @change="validarLongitudTelefono(i)"
          />
        </v-flex> 
        <v-flex xs12 md5 lg5 xl3 px-2>
          <v-text-field
            :name="'numTelefono[' + i + ']'"
            :label="$t('reservas.formularioFisico.telefono')"
            :rules="[rules.required, rules.integerNumber0, rules.max(14 - longitudPrefijo(comprador.codigoPrefijoTelefonicoId))]"
            v-model="comprador.numTelefono"
            ref="numTelefono"
          />
        </v-flex>
      </v-layout>
    </div>
    </v-form>
  </pop-up-layout>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import prefijos from '@/mixins/prefijos'
import rulesMixin from '@/mixins/rules.js'
export default {
  mixins: [rulesMixin, prefijos],
  props: {
    compradores: {
      type: Array,
      default: () => []
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mCompradores: [],
      inicializado: false,
      valid: false
    }
  },
  created () {
    this.mCompradores = this.compradores.map(c => {
      let prefijo, numTelefono
      ({prefijo, numTelefono} = this.separarTelefono(c.telefono, c.codigoPrefijoTelefonicoId))
      let retorno = {
        codigoPrefijoTelefonicoId: prefijo,
        numTelefono: numTelefono,
        telefono: c.telefono,
        email: c.email
      }
      if (c.id) {
        retorno.id = c.id
      }
      return retorno
    })
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual'
    })
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add'
    }),
    longitudPrefijo (codigoPrefijoTelefonicoId) {
      let pref = this.prefijos.find(x => x.id == codigoPrefijoTelefonicoId)
      if (pref == null) {
        return 0
      }
      return pref.codigo.length
    },
    async validarLongitudTelefono(i) {
      if (this.mCompradores[i].numTelefono != null) {
        await this.$nextTick()
        this.$refs.numTelefono[i].internalChange = true
        this.$refs.numTelefono[i].hasFocused = true
        this.$refs.numTelefono[i].validate()
      }
    },
    aceptar () {
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      this.mCompradores = this.mCompradores.map(c => {
        let prefijo = this.prefijos.find(x => x.id === c.codigoPrefijoTelefonicoId)
        return {
          ...c,
          telefono: (prefijo != null ? prefijo.codigo : '+34') + (c.numTelefono != null ? c.numTelefono : '')
        }
      })
      this.$emit('aceptar', this.mCompradores)
    },
    cambiado () {
      if (this.inicializado) {
        this.$emit('cambiado', true)
      }
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/comprador/ComprobarEmailTelefono.vue